import { COLOR_CLASS, findPerson, usePeople } from "@/lib/people";

// Colour + initials come from the people directory (Settings › Sales); anyone not in it gets a
// stable colour derived from their name so the same person always looks the same.
const FALLBACK = ["rose", "amber", "cyan", "indigo", "lime", "fuchsia"];

const initials = (name) => {
  const parts = String(name || "").trim().split(/[\s._-]+/).filter(Boolean);
  if (!parts.length) return "";
  if (parts.length === 1 && parts[0].length <= 3 && parts[0] === parts[0].toUpperCase()) return parts[0];
  return ((parts[0][0] || "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
};

const hashColor = (name) => {
  let hash = 0;
  for (const ch of String(name || "")) hash = (hash * 31 + ch.charCodeAt(0)) % 997;
  return FALLBACK[hash % FALLBACK.length];
};

export const usePersonLook = (ref) => {
  const { people } = usePeople();
  const p = findPerson(people, ref);
  return { person: p, name: p?.name || ref, initials: p?.initials || initials(ref), color: COLOR_CLASS[p?.color || hashColor(p?.name || ref)] };
};

/** Initials in a coloured circle; `name` may be a name, an email or initials. Em dash when nobody is assigned. */
export default function PersonChip({ name, testid, size = "h-6 w-6" }) {
  const look = usePersonLook(name);
  if (!name) return <span className="text-slate-300">—</span>;
  return (
    <span title={look.name} data-testid={testid}
          className={`inline-flex ${size} shrink-0 items-center justify-center rounded-full text-[10px] font-semibold ring-1 ${look.color}`}>
      {look.initials}
    </span>
  );
}
